import { deleteDoc, doc } from "@firebase/firestore"
import { showErrorSnackbar, showSuccessSnackbar } from "../../../shared/snackbar/snackbar-slice";
import { hideLoading, showLoading } from "./item-status-delete-slice";
import { deleteStatus } from "../item-status-list/item-status-list-slice";

// export const getItemStatusDataService = async (dispatch, db, coll, id) => {
//     try {
//         const docRef = doc(db, coll, id);
//         const docSnap = await getDoc(docRef);
//         if (docSnap.exists()) {
//             return docSnap.data();
//         } else {
//             dispatch(showWarningSnackbar("This document no longer exists."));
//         }
//     } catch(e) {
//         console.error("ItemStatusDelete getItemStatusDataService error: ", e);
//     }
// };

export const deleteItemStatusService = async (dispatch, db, coll, id) => {
    dispatch(showLoading());
    try {
        await deleteDoc(doc(db, coll, id));
        dispatch(deleteStatus(id));
        dispatch(showSuccessSnackbar('Deleted successfully!'));
    } catch(e) {
        dispatch(showErrorSnackbar('Delete failed! Please, try again.'));
        console.error("ItemStatusDelete deleteItemStatusService error: ", e);
    }
    dispatch(hideLoading());
};